export default {
  title: 'SEO',
  subtitle:
    'Dostosuj tytuł i opis wyświetlane w wynikach Google i podglądach społecznościowych. Pozostaw puste, aby użyć wartości domyślnych.',
  fields: {
    title: {
      label: 'Tytuł strony',
      placeholder: 'np. Forza Napoli — autentyczna neapolitańska pizza w Monachium',
      help: 'Wyświetlany jako nagłówek w wynikach Google i na kartach przeglądarki. Maks. 255 znaków; optymalnie 50–60 dla najlepszego podglądu.',
    },
    description: {
      label: 'Meta opis',
      placeholder: 'Krótkie podsumowanie restauracji widoczne pod tytułem w wynikach wyszukiwania.',
      help: 'Maks. 500 znaków; Google wyświetla zazwyczaj 150–160. Podkreśl, co wyróżnia Twoją restaurację.',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    saved: 'Ustawienia SEO zapisane',
    failed: 'Nie udało się zapisać ustawień SEO',
  },
};
